import React from "react";
import BasicModal from "./BasicModal";
import JsonPreview from "../common/JsonPreview";

const JsonPreviewModal = ({
  title = "JSON Preview",
  values,
  show,
  defaultCollapse,
  onClose,
}) => {
  return (
    <BasicModal show={show} title={title} onClose={onClose}>
      <JsonPreview defaultCollapse={defaultCollapse} values={values} />
    </BasicModal>
  );
};
export default JsonPreviewModal;
